import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    useRecordContext,
} from 'react-admin';
import { Button, IconButton, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import { ProjectPermitsDialog } from '@/modules/projects/ProjectPermitsDialog';

// Municipality CRUD lives inside /settings/* (not a react-admin Resource route),
// so every link targets an explicit /settings/municipalities/... path.
const ListActions = () => (
    <TopToolbar>
        <Button
            component={RouterLink}
            to="/settings/municipalities/create"
            startIcon={<AddIcon />}
            size="small"
        >
            Create
        </Button>
    </TopToolbar>
);

const RowActions = ({ onPermits }: { onPermits: (id: number) => void }) => {
    const record = useRecordContext<{ id: number }>();
    if (!record) return null;
    return (
        <>
            <Tooltip title="Permit documents">
                <IconButton size="small" onClick={() => onPermits(record.id)}>
                    <DescriptionOutlinedIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
                <IconButton
                    size="small"
                    component={RouterLink}
                    to={`/settings/municipalities/${record.id}`}
                >
                    <EditIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </>
    );
};

export const MunicipalityList = () => {
    const [permitsId, setPermitsId] = React.useState<number | null>(null);
    return (
        <>
            <List
                resource="municipalities"
                actions={<ListActions />}
                empty={false}
                perPage={25}
                sort={{ field: 'name', order: 'ASC' }}
                title="Municipalities"
            >
                <Datagrid rowClick={false} bulkActionButtons={false}>
                    <TextField source="name" />
                    <TextField source="key" />
                    <TextField source="folio_prefix" />
                    <TextField source="city_key" />
                    <RowActions onPermits={setPermitsId} />
                </Datagrid>
            </List>
            <ProjectPermitsDialog
                open={permitsId != null}
                municipalityId={permitsId ?? undefined}
                onClose={() => setPermitsId(null)}
            />
        </>
    );
};
